// External libraries
import React from 'react';
import type { ReactNode } from 'react';

// Internal modules
import { useStoreState } from '@/store';
import { PaypalThemedProvider } from '@/styles';
import { BodyText, HeadingText } from './StyledComponents';

interface SectionHeaderProps {
  color?: string;
  fontSize?: string;
  header: ReactNode;
  subheader?: ReactNode;
}

export const SectionHeader = ({
  header,
  subheader,
}: SectionHeaderProps): JSX.Element => {
  const showTabs = useStoreState(({ ui }) => ui.showTabs);

  return (
    <PaypalThemedProvider>
      <HeadingText level={2} showTabs={showTabs}>
        {header}
      </HeadingText>
      {subheader && <BodyText as="p">{subheader}</BodyText>}
    </PaypalThemedProvider>
  );
};
